import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import type { Skill } from "#types/types.ts";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

// One empty list while the skills load, so what's derived from it isn't rebuilt on every render.
const NO_SKILLS: Skill[] = [];

export const useConversationSkillsQuery = (isEnabled = true): Skill[] => {
    const { getSkills } = useAiApiClient();

    const { data } = useQuery({
        queryKey: AiQueryKeys.GetSkills(),
        queryFn: () => getSkills(),
        enabled: isEnabled
    });

    return data ?? NO_SKILLS;
};

// Resolves the same skill list without a render: the cached list, the request already in flight, or one fetch.
export const useEnsureConversationSkills = (): () => Promise<Skill[]> => {
    const { getSkills } = useAiApiClient();
    const queryClient = useQueryClient();

    return useCallback(() => queryClient.ensureQueryData({
        queryKey: AiQueryKeys.GetSkills(),
        queryFn: () => getSkills()
    }), [getSkills, queryClient]);
};
